(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-zenx-launch-end]').forEach((banner) => {
      if (banner.dataset.clockReady) return;
      const deadline = Date.parse(banner.dataset.zenxLaunchEnd);
      const clock = banner.querySelector('[data-launch-clock]');
      const fallback = banner.querySelector('[data-clock-fallback]');
      if (!Number.isFinite(deadline) || !clock) return;
      banner.dataset.clockReady = 'true';
      const fields = ['days', 'hours', 'minutes', 'seconds'].map((name) => clock.querySelector('[data-count-' + name + ']'));
      if (fields.some((field) => !field)) return;
      let timer;
      function update() {
        const remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        if (!remaining) {
          clock.hidden = true;
          fallback.hidden = true;
          banner.querySelector('.zx-launch-caption strong').textContent = 'The ZENX guides';
          banner.querySelector('[data-launch-caption]').textContent = 'The launch offer has ended.';
          if (timer) clearInterval(timer);
          return;
        }
        const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
        values.forEach((value, index) => { fields[index].textContent = String(value).padStart(2, '0'); });
        clock.hidden = false;
        fallback.hidden = true;
      }
      update();
      if (Date.now() < deadline) timer = setInterval(update, 1000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
